import { render } from "./notemodal.vue?vue&type=template&id=1601d4b0"
import script from "./notemodal.vue?vue&type=script&lang=js"
export * from "./notemodal.vue?vue&type=script&lang=js"

import "./notemodal.vue?vue&type=style&index=0&id=1601d4b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__